<template>
  <div id="shop-edition-product">
    <v-container grid-list-xl>
      <v-layout align-center row wrap>
        <v-flex sm10 xs12>
          <div class="headline">Shop Edition Product</div>
        </v-flex>
        <!-- <v-flex sm3 xs6>
          <v-autocomplete
            :items="users"
            clearable
            item-text="phone"
            item-value="phone"
            label="User"
            v-model="searchPhone"
          ></v-autocomplete>
        </v-flex>
        <v-flex sm3 xs6>
          <v-autocomplete
            :items="consultingTopics"
            clearable
            item-text="name"
            item-value="name"
            label="Topic"
            v-model="searchTopic"
          ></v-autocomplete>
        </v-flex>-->

        <v-flex sm2 text-xs-center xs12>
          <ShopEditionProductDialog />
        </v-flex>
        <v-flex xs12>
          <!-- Data Table -->
          <v-data-table
            class="elevation-0"
            disable-initial-sort
            :headers="headers"
            hide-actions
            :items="states"
            :loading="tableLoading"
          >
            <template slot="items" slot-scope="props">
              <tr @click="editItem(props.item.idx)">
                <td>{{ props.item.idx }}</td>
                <td>
                  <v-img
                    aspect-ratio="1"
                    height="40"
                    :src="
                      props.item.picture ? props.item.picture : require('@/assets/NoPicture.png')
                    "
                    width="40"
                  ></v-img>
                </td>
                <td>{{ mapShopEditionName(props.item.shopEditionId) || '-' }}</td>
                <td>{{ mapProductName(props.item.productId) }}</td>
                <td>{{ props.item.startDate || '-' }}</td>
                <td>{{ props.item.endDate || '-' }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import store from '@/store'

import ShopEditionProductDialog from '@/components/admin/ShopEditionProductDialog'
export default {
  name: 'shop-edition-product',
  components: {
    ShopEditionProductDialog
  },
  data() {
    return {
      users: [],
      searchPhone: '',
      searchTopic: '',
      // Table
      tableLoading: false,
      headers: [
        { text: 'ID', align: 'left', value: 'idx', width: '10' },
        { text: 'Picture', align: 'left', value: 'picture', width: '50' },
        { text: 'Shop Editon', align: 'left', value: 'shopEditionId', width: '300' },
        { text: 'Product', align: 'left', value: 'productId', width: '300' },
        { text: 'Start', align: 'left', value: 'startDate', width: '200' },
        { text: 'End', align: 'left', value: 'endDate', width: '200' }
      ]
    }
  },
  beforeRouteEnter: (to, from, next) => {
    store.state.ShopEditionProduct.data.length === 0 // main fetch
      ? store.dispatch('ShopEditionProduct/fetch').then(next())
      : next()
    if (store.state.ShopEdition.data.length === 0) store.dispatch('ShopEdition/fetch')
  },
  computed: {
    products() {
      return this.$store.state.Product.searchProducts
    },
    shopEditions() {
      return this.$store.getters['ShopEdition/getAll']
    },
    states() {
      return this.$store.getters['ShopEditionProduct/getAll']
    }
  },
  created() {},
  methods: {
    mapShopEditionName(idx) {
      return this.shopEditions
        .filter(item => item.idx == idx)
        .map(item => item.name)
        .toString()
    },
    mapProductName(productId) {
      return this.products
        .filter(item => item.productid == productId)
        .map(item => item.productname)[0]
    },
    editItem(idx) {
      this.$store.commit('ShopEditionProduct/UPDATE_DIALOG', true)
      this.$store.commit('ShopEditionProduct/SET_IDX', idx)
    }
  }
}
</script>

<style lang="scss" scoped></style>
